import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAvailablePromotionsApi } from 'src/services/oms'
import type { MetaStateInReducer } from '../meta'

export const fetchAvailablePromotionsAction = createAsyncThunk(
  '@promotion/fetchAvailablePromotions',
  async (params, thunkApi) => {
    const state = thunkApi.getState() as MetaStateInReducer
    const storeOrderId = state['@meta'].detailMenuSite.data
      .storeOrderId as string
    const mode = state['@meta'].detailMenuSite.mode
    const result = await getAvailablePromotionsApi({ storeOrderId, mode })
    return result.data
  }
)
